module.exports = __webpack_public_path__ + "media/videos/video-main-c79264b24412a00fe785ad50b35b5183.mp4";